<template>
  <HttpContentView :endpoint="utilities.path('modules/blog/categories/@', categoryId)">
    <template v-slot:content="{ data: category }">
      <HttpFormView :endpoint="!post ? utilities.path('modules/blog/categories/@/posts', categoryId) : utilities.path('modules/blog/posts/@', post?.id)" :method="!post ? 'post' : 'put'" :content="!post ? { published: true } : post" @success="emit('success')" @update:content="emit('update:changes', !post || JSON.stringify($event) !== JSON.stringify(post))">
        <template v-slot:form="{ content, errors, submit, loading }">
          <div class="d-flex flex-column g-4">
            <InputView type="text" :max="64" :value="content.title" @update:value="(content.slug ?? '') === utilities.slugify(content.title ?? '') ? content.slug = utilities.slugify($event) : undefined; content.title = $event" :title="translate('title')" :errors="errors.title" required/>
            <div>
              <InputView type="text" :max="64" :value="content.slug" @update:value="content.slug = utilities.slugify($event)" :title="translate('slug')" :errors="errors.slug" required>
                <template v-slot:extra>
                  <div class="bg-secondary p-1 rounded-3 text-foreground">
                    a-z, -, 0-9
                  </div>
                </template>
              </InputView>
              <div v-if="info.community && content.slug" class="text-muted small mt-2 ms-3">
                {{ info.community.domain ?? info.community.subdomain }}/blog/{{ category.slug }}/{{ content.slug }}
              </div>
            </div>
            <CheckboxInputView :title="translate('published')" v-model:value="content.published" color="primary" :errors="errors.published"/>
            <RichTextInputView v-model:value="content.content" :features="contentFeatures" :errors="errors.content ? Array.isArray(errors.content) ? errors.content : [translate('richText.format.invalid')] : undefined"/>
            <div class="d-flex align-items-center g-4">
              <ButtonView type="normal" color="primary" class="w-100" @click="submit" :disabled="loading">
                  <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                {{ translate("save") }}
              </ButtonView>
              <ButtonView type="normal" color="secondary" class="w-100" @click="emit('cancel')" :disabled="loading">
                {{ translate("cancel") }}
              </ButtonView>
            </div>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </template>
      </HttpFormView>
    </template>
  </HttpContentView>
</template>

<script setup>
import {InputView, utilities, ButtonView, SpinnerView, HttpFormView, HttpContentView, CheckboxInputView, richTextFeatures, RichTextInputView} from "@niftybit/vue";
import info from "../../../info";

const props = defineProps({
  categoryId: String,
  post: Object,
  changes: Boolean
});

const emit = defineEmits(["success", "cancel", "update:changes"]);

const contentFeatures = [
  richTextFeatures.paragraph.create(),
  richTextFeatures.text.create(),
  richTextFeatures.hardBreak.create(),
  richTextFeatures.heading.create(),
  richTextFeatures.textStyle.create(),
  richTextFeatures.codeBlock.create(),
  richTextFeatures.bulletList.create(),
  richTextFeatures.orderedList.create(),
  richTextFeatures.infoBox.create(),
  richTextFeatures.blockQuote.create(),
  richTextFeatures.textAlign.create(),
  richTextFeatures.code.create(),
  richTextFeatures.strikethrough.create(),
  richTextFeatures.bold.create(),
  richTextFeatures.underline.create(),
  richTextFeatures.italic.create(),
  richTextFeatures.link.create(),
  richTextFeatures.videoEmbed.create(),
  richTextFeatures.image.create().uploads(utilities.path("modules/blog/categories/@/images", props.categoryId), "post", ["png", "jpg"])
];

</script>